import { ServerRequestType, AssignmentValuesType } from './types';

export const transformSaveVehicleDriverAssignmentRequest = (
  values: AssignmentValuesType
): ServerRequestType => ({
  insuranceProducts: [
    {
      productType: 'personalAuto',
      insurableItemParties: Object.entries(values).map(
        ([vehicleId, driverAssignments]) => ({
          insurableItem: vehicleId,
          insurableParties: driverAssignments,
        })
      ),
    },
  ],
});
